import { createAsyncThunk } from '@reduxjs/toolkit';

const toggleVisualSearch = createAsyncThunk(
  'user/toggleVisualSearch',
  async (value, {
    rejectWithValue,
    extra: {
      sdk, Logger, utils, showErrorDialog,
    },
  }) => {
    try {
      await sdk.team.toggleVisualSearch(value);
      return value;
    } catch (error) {
      const errorMessage = utils.getDataFromResponseError(error, 'msg') || 'Can not be set team Visual Search';
      showErrorDialog(errorMessage);
      Logger.error(new Error(`Can not set team Visual Search [value: ${value}]`), { error }, [
        'UpdateTeamVisualSearchFailed',
        {
          errorMessage: (error && error.message) || 'NoMessage',
        },
      ]);
      return rejectWithValue(error);
    }
  },
);

export default toggleVisualSearch;
